import '@kerfjs/ui/select/register';

import { List } from '@kerfjs/ui/list';
import { Select } from '@kerfjs/ui/select';
import { TextField } from '@kerfjs/ui/text-field';
import { type SafeHtml } from 'kerfjs';

import { num } from './settings-value.js';

/** Organization profile form: name, country, base currency, and number grouping. */
export function OrgProfileView({ profile }: { profile: Record<string, unknown> }): SafeHtml {
  return (
    <List gap="m" controlInsets="trbl">
      <TextField type="text" name="p_name" label="Name" value={num(profile.name)} />
      <TextField type="text" name="p_country" label="Country" value={num(profile.country)} />
      <TextField type="text" name="p_currency" label="Base Currency" value={num(profile.baseCurrency)} />
      <Select<string>
        name="p_grouping"
        label="Number Grouping"
        value={typeof profile.numberGrouping === 'string' ? profile.numberGrouping : 'international'}
        choices={[
          { value: 'pakistani', label: 'Pakistani (12,50,000)' },
          { value: 'international', label: 'International (1,250,000)' },
        ]}
      />
    </List>
  );
}
